module.exports = __webpack_public_path__ + "img/introduction-img@1280w.fd7d8164.png";